"use client";
import React from "react";
import Image from "next/image";

interface Brand {
  name: string;
  iconSlug: string; // Simple Icons slug (e.g., 'microsoft', 'google')
}

// To add more brands, just add them to this array with their Simple Icons slug
// Visit https://simpleicons.org/ to find the exact slug for any brand
const brands: Brand[] = [
  { name: "Microsoft", iconSlug: "microsoft" },
  { name: "Google", iconSlug: "google" },
  { name: "Amazon", iconSlug: "amazon" },
  { name: "Apple", iconSlug: "apple" },
  { name: "Meta", iconSlug: "meta" },
  { name: "Netflix", iconSlug: "netflix" },
  { name: "Spotify", iconSlug: "spotify" },
  { name: "Adobe", iconSlug: "adobe" },
  { name: "Shopify", iconSlug: "shopify" },
  { name: "Salesforce", iconSlug: "salesforce" },
  { name: "GitHub", iconSlug: "github" },
  { name: "Discord", iconSlug: "discord" },
  // Test with a long company name to demonstrate seamless scrolling
  { name: "JPMorgan Chase & Co", iconSlug: "chase" }
  // Add more brands here:
  // { name: "Your Brand", iconSlug: "yourbrand" },
];

const elements = brands.map((brand, brandIndex) => (
  <div key={`brand-${brandIndex}`} className="cursor-default flex items-center space-x-3 text-gray-400 hover:text-gray-600 transition-all duration-300 whitespace-nowrap flex-shrink-0 group">
    <Image
      src={`/images/icons/${brand.iconSlug}.svg`}
      alt={`${brand.name} logo`}
      width={32}
      height={32}
      className="transition-all duration-300 group-hover:opacity-80"
      style={{
        filter: 'brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(96%) contrast(97%)',
        opacity: '0.6'
      }}
    />
    <span className="text-lg font-medium">{brand.name}</span>
  </div>
));

export default function BrandScroller() {
  return (
    <div className="relative overflow-hidden">
      {/* Fade gradients */}
      <div className="absolute left-0 top-0 w-20 h-full bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 w-20 h-full bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      
      {/* Scrolling container with triple duplication for perfect seamless loop */}
      <div className="flex">
        <div className="flex items-center space-x-12 px-6 flex-shrink-0 animate-loop-scroll">
          {elements}
        </div>

        <div className="flex items-center space-x-12 px-6 flex-shrink-0 animate-loop-scroll" aria-hidden="true">
          {elements}
        </div>
      </div>
    </div>
  );
}
